import {Suspense} from 'react'
import PropTypes from 'prop-types'
import {
  Tab,
  TabPanel,
  TabList,
  TabPanels,
  Tabs,
  useBreakpointValue,
  Skeleton,
} from '@chakra-ui/react'
import {NewSupplierLayout as SupplierLayout} from '../../layouts/SupplierLayout'
import {AuthProvider} from '../../contexts/authentication'
import withProviders from '../../contexts/withProviders'
import TabContentLoading from './Tabs/LoadingState'
import SmallScreenTabMenu from './SmallScreenTabMenu'
import {useTabs} from './useTabs'

const SettingsScreen = withProviders(({authenticityToken, settingsUrls}) => {
  const {tabs, tabIndex, changeTabs, currentTabObject, isLoading} = useTabs({
    settingsUrls,
  })

  const mobileView = useBreakpointValue({
    base: true,
    md: false,
  })

  return (
    <AuthProvider authenticityToken={authenticityToken}>
      <SupplierLayout state="Settings" variant="secondary">
        <Skeleton isLoaded={!isLoading}>
          <Tabs isLazy index={tabIndex} onChange={changeTabs}>
            <TabList className="fs-unmask" mb="sm" border="0">
              {mobileView ? (
                <SmallScreenTabMenu
                  key="smallScreenMenu"
                  tabs={tabs}
                  currentTabObject={currentTabObject}
                  changeTabs={changeTabs}
                />
              ) : (
                tabs.map(({tabName, label}) => <Tab key={tabName}>{label}</Tab>)
              )}
            </TabList>
            <TabPanels>
              {tabs.map(({tabName, component}) => (
                <TabPanel key={tabName} p="0">
                  <Suspense fallback={<TabContentLoading />}>
                    {component}
                  </Suspense>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Skeleton>
      </SupplierLayout>
    </AuthProvider>
  )
})

SettingsScreen.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  settingsUrls: PropTypes.shape({
    general: PropTypes.string.isRequired,
    accounting: PropTypes.string.isRequired,
    banking: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    paymentMethods: PropTypes.string.isRequired,
    rewards: PropTypes.string.isRequired,
  }).isRequired,
}

export default SettingsScreen
